import { CommonHeader } from '~/components';
import styles from './Stats.module.scss';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useStore } from '~/store';
import { getDayMonth } from '~/utils/datetime';
import { optionsType } from '~/constants/options';
import { toSringKVnd } from '~/utils/money';
import Checkbox from '~/components/checkbox/Checkbox';

const getStatType = () => {
    return optionsType.map((type) => ({
        ...type,
        total: 0,
        checked: type.name === 'Chùa' || type.name === 'Xe' ? false : true,
    }));
};

function Stats() {
    const [state] = useStore();
    const { moneys } = state;
    const [showStatsType, setShowStatsType] = useState(true);
    const [showStatsPagoda, setShowStatsPagoda] = useState(true);
    const [showStatsHotel, setShowStatsHotel] = useState(true);

    const [statsType, setStatsType] = useState(getStatType());
    // console.log('statsType', statsType);

    const createStatsByPagoda = () => {
        let statsPagoda = moneys.filter((money) => money.type === 'Chùa');
        statsPagoda = statsPagoda.sort((a, b) => {
            if (a.id > b.id) return 1;
            if (a.id < b.id) return -1;
            return 0;
        });

        const list = [];
        statsPagoda.forEach((pagoda) => {
            const item = list.find((ele) => ele.placeId === pagoda.placeId);
            if (item) {
                item.pagodas.push(pagoda);
            } else {
                list.push({
                    placeId: pagoda.placeId,
                    placeName: pagoda.placeName,
                    pagodas: [pagoda],
                });
            }
        });

        if (list.length === 0) return <div>Chưa có dữ liệu thống kê</div>;

        return list.map((item) => (
            <div key={item.placeName}>
                <div className={styles.subTitle}>{item.placeName}</div>
                <ul className={styles.content}>
                    {item.pagodas.map((pagoda) => (
                        <li key={pagoda.id}>
                            <div>
                                {'- '}
                                {pagoda.name}
                            </div>
                            <div>{pagoda.amount + 'k'}</div>
                        </li>
                    ))}
                </ul>
            </div>
        ));
    };

    const createStatsByHotel = () => {
        let statsHotel = moneys.filter((money) => money.type === 'Khách sạn');
        statsHotel = statsHotel.sort((a, b) => {
            if (a.datetime > b.datetime) return 1;
            if (a.datetime < b.datetime) return -1;
            return 0;
        });

        if (statsHotel.length === 0) return <div>Chưa có dữ liệu thống kê</div>;

        return statsHotel.map((hotel) => (
            <div className={styles.hotel} key={hotel.datetime}>
                <div className={styles.row}>
                    <div>{getDayMonth(hotel.datetime)}</div>
                    <div>{hotel.placeName}</div>
                </div>
                <div key={hotel.id} className={clsx(styles.row, styles.subRow)}>
                    <div>{hotel.name}</div>
                    <div className={styles.amount}>
                        {toSringKVnd(hotel.amount)}
                    </div>
                </div>
            </div>
        ));
    };

    const handleOnChange = (name) => () => {
        setStatsType((pre) => {
            return pre.map((stat) => {
                if (stat.name === name) stat.checked = !stat.checked;
                return stat;
            });
        });
    };

    useEffect(() => {
        setStatsType((pre) => {
            return pre.map((stat) => ({
                ...stat,
                total: moneys.reduce((accumulator, currentMoney) => {
                    if (currentMoney.type === stat.name)
                        return accumulator + currentMoney.amount;
                    return accumulator;
                }, 0),
            }));
        });
    }, [moneys]);
    return (
        <div className={styles.wrapper}>
            <CommonHeader title={'THỐNG KÊ'} />
            <div className={styles.list}>
                <div className={clsx(styles.common, styles.type)}>
                    <div
                        className={styles.title}
                        onClick={() => setShowStatsType((pre) => !pre)}
                    >
                        <i className="fa-solid fa-landmark"></i> Tổng tiền theo
                        loại
                    </div>
                    {showStatsType && (
                        <div className={styles.stats}>
                            <ul className={styles.content}>
                                {statsType.map((stat) => (
                                    <li
                                        key={stat.name}
                                        className={clsx(
                                            stat.checked === false &&
                                                styles.inactive,
                                        )}
                                    >
                                        <Checkbox
                                            title={stat.name}
                                            onChange={handleOnChange(stat.name)}
                                            checked={stat.checked}
                                        />
                                        <div className={styles.underline}></div>
                                        <div
                                            className={clsx(
                                                stat.checked && styles.active,
                                            )}
                                        >
                                            {toSringKVnd(stat.total)}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className={styles.total}>
                                {toSringKVnd(
                                    statsType.reduce(
                                        (accumulator, currentStat) => {
                                            if (currentStat.checked)
                                                return (
                                                    accumulator +
                                                    currentStat.total
                                                );
                                            return accumulator;
                                        },
                                        0,
                                    ),
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className={clsx(styles.common, styles.pagoda)}>
                    <div
                        className={styles.title}
                        onClick={() => setShowStatsPagoda((pre) => !pre)}
                    >
                        <i className="fa-solid fa-vihara"></i> Các Chùa đã viếng
                    </div>
                    {showStatsPagoda && (
                        <div className={styles.stats}>
                            {createStatsByPagoda()}
                        </div>
                    )}
                </div>

                <div className={clsx(styles.common, styles.hotel)}>
                    <div
                        className={styles.title}
                        onClick={() => setShowStatsHotel((pre) => !pre)}
                    >
                        <i className="fa-solid fa-hotel"></i> Các Khách sạn đã ở
                    </div>
                    {showStatsHotel && (
                        <div className={styles.stats}>
                            {createStatsByHotel()}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Stats;
